export const SOCKET_URL = 'https://io.dev.plantika.co.il';
export const API = 'https://api.dev.plantika.co.il';
export const SENTRY_DSN  = 'https://553a8d597e77ff5defc613309272887d@o4509100818432000.ingest.de.sentry.io/4509100916867152';
export const SENTRY_ENV = 'development';

